module.exports = __webpack_public_path__ + "static/media/50.269913b1.jpg";